import { render, staticRenderFns } from "./Project.vue?vue&type=template&id=077bbd73&"
import script from "./Project.vue?vue&type=script&lang=js&"
export * from "./Project.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/neuronet/projekty/gantt-elastic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('077bbd73')) {
      api.createRecord('077bbd73', component.options)
    } else {
      api.reload('077bbd73', component.options)
    }
    module.hot.accept("./Project.vue?vue&type=template&id=077bbd73&", function () {
      api.rerender('077bbd73', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Chart/Row/Project.vue"
export default component.exports